<template>
	<view class="jc-page-wrap"><slot></slot></view>
</template>

<script>
export default {
	name: 'jc-page',
	data() {
		return {};
	}
};
</script>

<style lang="scss" scoped>
/* -- 页面 -- */
.jc-page-wrap {
	min-height: 100vh;
	background-color: $uni-bg-color-grey;
}
</style>
